import { render, staticRenderFns } from "./holidayConfig.vue?vue&type=template&id=35032a7b&scoped=true"
import script from "./holidayConfig.vue?vue&type=script&lang=ts"
export * from "./holidayConfig.vue?vue&type=script&lang=ts"
import style0 from "./holidayConfig.vue?vue&type=style&index=0&id=35032a7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35032a7b",
  null
  
)

export default component.exports